<template>
  <button type="button" class="def-remove">
    <svg class="def-remove__icon"><use xlink:href="#svg-trash"></use></svg>
  </button>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.def-remove {
  cursor: pointer;
  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    fill: #030304;
    transition: 0.2s linear fill;
  }
  &:hover {
    .def-remove__icon {
      fill: var(--color-red);
    }
  }
}
</style>
